import React, { useEffect, useRef } from 'react';

const PaymentFormLocal = ({ htmlInfo }) => {
  const containerRef = useRef(null);
  const scriptsRef = useRef([]);
  
  useEffect(() => {
    if (!htmlInfo || !htmlInfo.html) {
      console.error("Données HTML manquantes pour le paiement");
      return;
    }
    
    const loadExternalScript = (src) => {
      return new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${src}"]`)) {
          resolve();
          return;
        }
        
        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        
        document.head.appendChild(script);
        scriptsRef.current.push(script);
      });
    };

    const injectHTML = async () => {
      try {
        if (htmlInfo.js) {
          await loadExternalScript(htmlInfo.js);
        }
        
        if (containerRef.current) {
          containerRef.current.innerHTML = htmlInfo.html;
          
          const scripts = containerRef.current.querySelectorAll('script');
          scripts.forEach(script => {
            try {
              const newScript = document.createElement('script');
              if (script.src) {
                newScript.src = script.src;
              } else {
                newScript.textContent = script.textContent;
              }
              
              script.parentNode.replaceChild(newScript, script);
              scriptsRef.current.push(newScript);
            } catch (error) {
              console.error('Erreur lors de l\'exécution du script:', error);
            }
          });
        }



      } catch (error) {
        console.error("Erreur lors de l'injection:", error);
      }
    };
    
    injectHTML();
    
    return () => {
      scriptsRef.current.forEach(script => {
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      });
      scriptsRef.current = [];
      
      if (containerRef.current) {
        containerRef.current.innerHTML = '';
      }
    
    };
  }, [htmlInfo]);
  
  return (
    <div 
      ref={containerRef} 
      className="payment-container"
      style={{ minHeight: '656px',minWidth:"400px" }}
    />
  );
};
export default PaymentFormLocal;